import { Component, Input } from '@angular/core';
import { CAMAPANHA_ROI_KPI_RECURSOS } from '../../../campanha-roi-kpi';

@Component({
    selector: 'sgt-campanha-roi-widget-recurso',
    templateUrl: './campanha-roi-widget-recurso.component.html',
    styleUrls: ['./campanha-roi-widget-recurso.component.less']
})
export class CampanhaROIWidgetRecursoComponent {
    readonly KPI = CAMAPANHA_ROI_KPI_RECURSOS;

    @Input() isLoading: boolean;
    @Input() valorTotalRecursos = 0;
}
